import { render, staticRenderFns } from "./StudentReportStatus.vue?vue&type=template&id=44899018"
import script from "./StudentReportStatus.vue?vue&type=script&lang=js"
export * from "./StudentReportStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports